<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            <h4
              style="color: #000; text-align: left"
              class="sub-title-header ml-4"
            >
              Select one
            </h4>
            <br />
            <CCard class="custom-bg-color d-sm-down-none" @click="GoToRegStudParent()">
              <CRow>
                <div style="width: 60%" class="float-left">
                  <h3
                    style="text-align: left; margin: 20px 30px"
                    class="sub-title-header"
                  >
                    I’m a Parents <br />
                    and want to register <br />
                    for my kids
                  </h3>
                </div>
                <div style="width: 20%" class="float-right">
                  <img style="
                      max-width: 100%;
                      right: 0;
                      position: absolute;
                      bottom: 0;
                    "
                     src="../assets/img/icon/Parents-bro1.svg" />
                </div>
                <div style="clear:both"></div>
              </CRow>
            </CCard>

            <CCard class="custom-bg-color mt-3 d-sm-down-none" @click="GoToRegStud()">
              <CRow>
                <div style="width: 60%" class="float-left">
                  <h3
                    style="text-align: left; margin: 20px 30px"
                    class="sub-title-header"
                  >
                    I’m a student<br />
                    and want to register <br />
                    for myself<br />
                  </h3>
                </div>
                <div style="width: 20%" class="float-right">
                  <img  style="
                      max-width: 100%;
                      right: 0;
                      position: absolute;
                      bottom: 0;
                    "
                     src="../assets/img/icon/vectorstudent.svg" />
                </div>
              </CRow>
            </CCard>




            <CCard class="custom-bg-color d-flex d-md-none" @click="GoToRegStudParent()">
              <CRow>
                <div style="width: 60%" class="float-left">
                  <h3
                    style="text-align: left; margin: 20px 30px"
                    class="sub-title-header"
                  >
                    I’m a Parents <br />
                    and want to register <br />
                    for my kids
                  </h3>
                </div>
                <div style="width: 20%" class="float-right">
                  <img src="../assets/img/icon/Parents-bro1.svg" />
                </div>
                <div style="clear:both"></div>
              </CRow>
            </CCard>

            <CCard class="custom-bg-color mt-3 d-flex d-md-none" @click="GoToRegStud()">
              <CRow>
                <div style="width: 60%" class="float-left">
                  <h3
                    style="text-align: left; margin: 20px 30px"
                    class="sub-title-header"
                  >
                    I’m a student<br />
                    and want to register <br />
                    for myself<br />
                  </h3>
                </div>
                <div style="width: 20%" class="float-right">
                  <img src="../assets/img/icon/vectorstudent.svg" />
                </div>
              </CRow>
            </CCard>
          </div>
        </div>
      </div>
      <MainlayoutBottom></MainlayoutBottom>
    </CContainer>
    <div class="header-top">Register Student</div>
    <div class="header-left">
      <img src="../assets/img/icon/VectorLeft.svg" @click="GoBack()"/>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import MainlayoutBottom from "../containers/TheBottomCustom.vue";
export default {
  components: {
    MainlayoutBottom,
  },
  methods: {
    GoToRegStudParent(){
      this.$router.push(
        "/RegisterStudentParent"
      );
    },
    GoToRegStud(){
      this.$router.push(
        "/RegisterStudentGrade"
      );
    },
    GoBack() {
      this.$router.back();
    },
  }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
body {
  font-family: "Montserrat", sans-serif;
}

</style>